import { Box, Text, getPaletteColor } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

const Cell = styled(Box)`
  display: inline-block;
  vertical-align: top;
  line-height: 1.8;
  text-align: center;
  width: 100%;
  height: 50px;
`
const Price = styled(Box)`
  color: ${(props) =>
    props.isSelected ? getPaletteColor('text.lightest') : getPaletteColor('pricePrimary.base')};
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
`

export class CustomDayWithPrice extends React.Component {
  static defaultProps = {
    isValid: false,
  }

  currency = '$'

  render() {
    const { day, customDayProps, isGrouped, isSelected, isValid, use2024DesignSeti } = this.props
    const displayedPrice = isValid && customDayProps ? `${this.currency}${customDayProps.price}` : ''

    return (
      <Cell m={use2024DesignSeti ? '2px' : undefined}>
        <Text fontSize={2} fontWeight={use2024DesignSeti ? 'normal' : 'bold'}>
          {day}
        </Text>
        {displayedPrice && (
          <Price isGrouped={isGrouped} isSelected={isSelected}>
            {displayedPrice}
          </Price>
        )}
      </Cell>
    )
  }
}

export default CustomDayWithPrice
